












import Vue from "vue";
import { authentication } from "@/stores";
import "./main.scss";
import { Route } from "vue-router";
import Header from "@/views/common/Header.vue";
import Side from "@/views/common/Side.vue";

export default Vue.extend({
  name: "Main",
  components: { Side, Header },
  data() {
    return {
      authentication,
      transitionName: ""
    };
  },
  computed: {
    isAnnounce(): boolean {
      return this.$route.path.startsWith("/announce");
    }
  },
  watch: {}
});
